import React from 'react';
import { connect } from 'react-redux';
import { Modal, Form, message, InputNumber } from 'antd';
import * as actionTypes from '../../redux/actions/seniormaster/actionTypes';
import { updatePartnerShare } from '../../redux/actions/seniormaster/updateSeniormaster';

const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 12 },
};

class UpdatePartnerShareModal extends React.Component {
    constructor(props) {
        super(props);
        this.form = React.createRef();
    }
    onFinish = async (values) => {
        await this.props.onUpdate({
            id:this.props.smaster?.id,
            sharePercentage:values.sharePercentage
        },
            this.props.token);
        if (this.props.error) {
            message.error(this.props.error);
        }
        if (this.props.message) {
            message.success(this.props.message);
        }
        this.form.current.resetFields();
        this.props.onClose();
    }
    onFinishFailed = (errors) => {
        console.log(errors)
    }
    handleCancel = () => {
        this.props.onClose();
    }
    render() {
        return (
            <Modal
                title="Update Partner Share"
                key={this.props.smaster?.id}
                centered
                visible={this.props.visible}
                okButtonProps={{ form: 'update-ps-form', key: 'submit', htmlType: 'submit' }}
                confirmLoading={this.props.loading}
                onCancel={this.handleCancel}
                okText="Save"
                loading={this.props.loading}
            >
                <Form
                {...layout}
                    ref={this.form}
                    style={{ margin: 25 }}
                    id="update-ps-form"
                    name="basic"
                    initialValues={{
                        sharePercentage:this.props.smaster?.partnerShare,
                    }}
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Form.Item
                        name="sharePercentage"
                        label="Share Percentage"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <InputNumber  style={{width:150}}/>
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}

const mapStateToProps = state => ({
    visible: state.seniorMaster.updatePartnerShareVisible,
    loading: state.seniorMaster.loading,
    token: state.auth.token,
    error: state.seniorMaster.error,
    message: state.seniorMaster.message,
    smaster:state.seniorMaster.one
})

const mapDispatchToProps = dispatch => ({
    onUpdate: (share, token) => dispatch(updatePartnerShare(share, token)),
    onClose: () => dispatch({
        type:actionTypes.TOGGLE_PARTNER_SHARE_UPDATE
    }),
})

export default connect(mapStateToProps, mapDispatchToProps)(UpdatePartnerShareModal);